import React, { useState } from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';
// import { IconImg } from '../../../StyledComponents/Header';
import { UserOutlined } from '@ant-design/icons';

const { Option } = Select;

function SelectSearchAirline(props) {
    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (value) => {
        setSearchValue(value);
    };

    const handleSelect = (value) => {
        // const selectedOption = props.options.find(option => option.id === value);
        props.setFieldValue(props.name,value)
        if(props.name === 'carr_code'){
            props.setFieldValue('num_code','')
            props.setFieldValue('airline','')
        }else if(props.name === 'num_code'){
            let airline = props.options?.filter((i)=> i.num_carr_code === value)[0]?.carr_name
            props.setFieldValue('airline',airline)
        }
    }

    const filterOption = (input, option) => {
        const { value, children } = option.props;
        return (
          children.toString().toLowerCase().includes(input.toLowerCase())
        );
      };
  return (
    <SpaceItem wrap gap={props.gap} mr={props.mr} mb={props.mb}>
        <ItemSelect
            showSearch
            size={props.size ? props.size : "large"}
            placeholder={props.placeholder ?props.placeholder : "Select"}
            // style={{
            //     width: props.width? props.width : 230,
            // }}
            // onChange={handleSelect}
            onChange={(value) => {
                props.setFieldValue(props.name,value)
                if(props.name === 'carr_code'){
                    let carr_instance = props.options?.filter((i)=> i.carr_code === value)[0]
                    let num_code = carr_instance.num_carr_code
                    let airline = carr_instance.carr_name
                    props.setFieldValue('num_code',num_code)
                    props.setFieldValue('airline',airline)
                } else if(props.name === 'num_code'){
                    let airline = props.options?.filter((i)=> i.num_carr_code === value)[0]?.carr_name
                    props.setFieldValue('airline',airline)
                }
              }}
            onSearch={handleSearch}
            filterOption={filterOption}
            value={props.value}
            bradius={props.bradius}
            width= {props.width}
        >
            {props.options?.map((i,index)=> 
                props.name === 'carr_code' ? 
                <Option key={index} value={i.carr_code}>{i.carr_code}</Option> :
                props.name === 'num_code' ? 
                <Option key={index} value={i.num_carr_code}>{i.num_carr_code}</Option> :
                <Option key={index} value={i.id}>{i.carr_name}</Option>
            )}   
        </ItemSelect>
    </SpaceItem>
  )
}

export default SelectSearchAirline

const SpaceItem = styled(Space)`
    position: relative;
    gap: ${({gap})=> gap ? gap : '8px'};
    margin-right: ${({mr})=> mr? mr : "unset"};
    margin-bottom: ${({mb})=> mb? mb : "unset"};
    & .ant-space-item {
        width: 100%;
    }
`
const ItemSelect = styled(Select)`
    width: ${({width}) => width ? width : '230px'};
    & .ant-select-selector {
        border-radius: ${({bradius}) => bradius? bradius : "4px !important;"};
        padding-left: ${({ is_icon })=> is_icon ? "20px !important": 'unset'};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important;
    }
`